/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Avatar from 'funifier-nice-avatar';
import Box from 'components/ui/box';
import ReactModal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { TbAlertTriangle, TbBulbFilled, TbClockPause, TbFlower, TbPlant2, TbSearch, TbSeeding } from 'react-icons/tb';
import InputMask from 'react-input-mask';
import { findPlayer } from 'services/profile.service';
import { User } from 'types/user';
import { RiCloseLine } from 'react-icons/ri';
import { IoMdCloseCircle } from 'react-icons/io';
import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';
import { GetMoedaDescription } from 'utils/strings';

import { format } from 'date-fns';

import './style.scss';
import { UserAvatar } from 'components/user-avatar';
import { DIMENSOES, dimensaoByBehavior, gigabytesToSelos, hexToRgba, nivelByMoeda } from 'components/rebrand/mappings';
import { DimGlyph } from 'components/rebrand/icons';

import { getPlayerInfo, getServerTime } from 'services/dashboard.service';
import TextEditor from 'components/text-editor';
import { AiOutlineWarning } from 'react-icons/ai';
import Modal from './Modal/Index';
import { BiInfoCircle } from 'react-icons/bi';
import { convertEmojis } from 'utils/helpers';
import Tippy from '@tippyjs/react';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';

const maskTemplate = 'F9999999';

const FEEDBACK_ICON_SIZE = 40;

const ICONE_POR_NIVEL: Record<string, JSX.Element> = {
  semeou: <TbSeeding size={FEEDBACK_ICON_SIZE} />,
  cresceu: <TbPlant2 size={FEEDBACK_ICON_SIZE} />,
  floriu: <TbFlower size={FEEDBACK_ICON_SIZE} />,
};

export default function Reconhecer() {
  const navigate = useNavigate();
  const params = useParams();
  const [queryParams] = useSearchParams();
  const pearsonRef = useRef<HTMLDivElement>(null);
  const behaviorRef = useRef<HTMLDivElement>(null);
  const recognitionRef = useRef<HTMLDivElement>(null);
  const feedbackRef = useRef<HTMLDivElement>(null);
  const sendedRef = useRef<HTMLDivElement>(null);
  const feedbackServer = useRef<HTMLDivElement>(null);

  const { user, refreshUser, currentCycle } = useAuth();
  const { showModal, closeModal } = useModal();
  const { helpData } = useHelp();

  const searchRef = useRef<any>();
  const messageRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [searched, setSearched] = useState(false);
  const [target, setTarget] = useState<User>();
  const [behavior, setBehavior] = useState<string>();
  const [coin, setCoin] = useState<string | undefined>();
  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [playerInfo, setPlayerInfo] = useState<any>({});
  const [showModalItem, setshowModalItemItem] = useState(false);

  const [step, setStep] = useState(0);

  const [submitMessage, setSubmitMessage] = useState<string | undefined>();
  const [submitStatus, setSubmitStatus] = useState<string | undefined>();
  const [hasSubmitError, setHasSubmitError] = useState<boolean>(false);
  const [submitEmAnalise, setSubmitEmAnalise] = useState<boolean>(false);

  const [mask, setMask] = useState('');

  useEffect(() => {
    const close = (e: any) => {
      if (e.keyCode === 27) {
        handleCloseModal();
      }
      console.log(e.keyCode);
    };
    window.addEventListener('keydown', close);

    return () => window.removeEventListener('keydown', close);
  }, []);

  useEffect(() => {
    if (!!pearsonRef && pearsonRef.current) {
      setTimeout(() => {
        pearsonRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }
    if (!!behaviorRef && !!behaviorRef.current) {
      setTimeout(() => {
        behaviorRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!recognitionRef && !!recognitionRef.current) {
      setTimeout(() => {
        recognitionRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!feedbackRef && !!feedbackRef.current) {
      setTimeout(() => {
        feedbackRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!sendedRef && !!sendedRef.current) {
      setTimeout(() => {
        sendedRef.current?.querySelector('a')?.focus();
      }, 300);
    }
  }, [step]);

  const minTextLength = 100;

  const maxTextLength = 600;

  ReactModal.setAppElement('#modal');

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  async function handleSearch(e?: any) {
    if (e) {
      e.preventDefault();
    }
    try {
      const matricula = searchRef.current.value.replace('_', '');

      if (!matricula || matricula === user?._id) {
        return;
      }

      setSearching(true);
      const result = await findPlayer(searchRef.current.value);
      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      if (filteredResults.length === 1) {
        setTarget(filteredResults[0]);
      } else {
        setSearchResults(filteredResults);

        setIsEmpty(filteredResults?.length === 0 && matricula.startsWith('F') && matricula.slice(1).match(/^[0-9]+$/) != null);
      }
      setSearching(false);
      setSearched(true);
    } catch (e) {
      setSearching(false);
    }
  }

  async function handleSubmit() {
    try {
      if (
        loading ||
        !target ||
        !behavior ||
        !coin ||
        !message ||
        !messageLength ||
        messageLength.textLength < minTextLength ||
        messageLength.fullLength > maxTextLength
      )
        return;

      setLoading(true);

      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        return toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      const log = await actionLog('me', 'reward_behavior', {
        target: target?._id,
        behavior,
        coin,
        message,
      });

      setLoading(false);
      setSubmitted(true);
      refreshUser();

      if (log.action && log.action.attributes.status && log.action.attributes.status !== 'OK') {
        setHasSubmitError(true);
        // código de status da regra de negócio (limite/auto/lideranca/sem fundos/fase/duplicado/inativo)
        setSubmitStatus(log.action.attributes.status);

        if (!!log?.action?.attributes?.systemMessage) {
          setSubmitMessage(log?.action?.attributes?.systemMessage);
        } else {
          setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, antes de tentar novamente, verifique no seu histórico se o reconhecimento foi realizado.');
        }
      } else if (log.action && log.action.attributes.status && log.action.attributes.status === 'OK') {
        setHasSubmitError(false);
        setSubmitEmAnalise(log?.action?.attributes?.moderation_hold === true);

        if (!!log?.action?.attributes?.systemMessage) {
          setSubmitMessage(log?.action?.attributes?.systemMessage);
        } else if (log?.action?.attributes?.moderation_hold === true) {
          setSubmitMessage(
            'Seu reconhecimento está em análise e ainda não foi entregue ao seu colega. Os selos já saíram do seu saldo e voltam caso ele não seja aprovado.',
          );
        } else {
          setSubmitMessage(
            'Você reconheceu um colega. Agradecemos por ajudar a tornar o ambiente colaborativo e agradável para trabalhar.',
          );
        }
      }
    } catch (e) {
      setLoading(false);
      setSubmitted(true);
      refreshUser();
      setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, antes de tentar novamente, verifique no seu histórico se o reconhecimento foi realizado.');
      setSubmitStatus(undefined); // erro transitório/rede → retentável
      setHasSubmitError(true);
    }

    if (!!feedbackServer && !!feedbackServer.current) {
      setTimeout(() => {
        feedbackServer.current?.querySelector('h1')?.focus();
      }, 300);
    }
  }

  function reset() {
    setTarget(undefined);
    setBehavior(undefined);
    setCoin(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitMessage(undefined);
    setSubmitStatus(undefined);
    setHasSubmitError(false);
    setSubmitEmAnalise(false);
    setSearchResults([]);
    setSearching(false);
    setMessage(undefined);
    setMessageLength(undefined);
    setStep(0);
  }

  function handleCloseModal() {
    reset();
    navigate('../');
  }

  // Recusa por moderação é retentável, mas não do mesmo jeito que um erro
  // transitório: o texto recusado precisa ficar disponível para edição, não
  // desaparecer. Por isso este caminho não passa por reset() — ele limpa só o
  // resultado do envio e devolve o participante ao passo da mensagem,
  // preservando target/behavior/coin/message.
  function handleReviewMessage() {
    setSubmitted(false);
    setSubmitMessage(undefined);
    setSubmitStatus(undefined);
    setHasSubmitError(false);
    setStep(3);
  }

  function hasEnoughCoins(coin_type: string) {
    try {
      if (!user) {
        return true;
      }

      if (!user?.point_categories?.point_behavior || user?.point_categories?.point_behavior < 100) {
        return false;
      }

      switch (coin_type) {
        case 'uau':
          if (user?.point_categories?.point_behavior - 300 >= 0) {
            return true;
          } else {
            return false;
          }
        case 'mandou':
          if (user?.point_categories?.point_behavior - 200 >= 0) {
            return true;
          } else {
            return false;
          }
        case 'valeu':
          if (user?.point_categories?.point_behavior - 100 >= 0) {
            return true;
          } else {
            return false;
          }
        default:
          return true;
      }
    } catch (e) {
      return true;
    }
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    if (!!element) {
      element?.focus();
    }
  }

  function afterOpenModal() {
    focusOnElement('.rb-recognize__header h2');
  }

  function handleChangeMessage(value: string) {
    setMessage(value);
    setMessageLength({ textLength: value.trim().length, fullLength: value.length });
  }

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('/');
      }

      const data = await getPlayerInfo(user?._id);
      setPlayerInfo(data);
    }

    if (!!currentCycle) {
      playerCanView();
    }
  }, [currentCycle, navigate]);

  useEffect(() => {
    setTimeout(() => {
      if (!searching && searchRef && searchRef.current && params && params.id) {
        searchRef.current.value = params.id;
        handleSearch();
      }
    }, 1000);
  }, [params]);

  // Pré-seleciona a dimensão quando aberto a partir de um card de comportamento
  // (ex.: /reconhecer?behavior=colaboracao). O usuário ainda pode trocar no passo 2.
  useEffect(() => {
    const preBehavior = queryParams.get('behavior');
    if (preBehavior && DIMENSOES.some(d => d.id === preBehavior)) {
      setBehavior(preBehavior);
    }
  }, [queryParams]);

  // Regulamento: "Liderança Inspiradora" só p/ alvo gerencial — se o alvo não é gestor, limpa a seleção.
  useEffect(() => {
    if (behavior === 'lideranca' && !target?.isLeader) setBehavior(undefined);
  }, [target, behavior]);

  useEffect(() => {
    if (
      !!target &&
      !!playerInfo &&
      Array.isArray(playerInfo.relacionamentos) &&
      !!playerInfo?.relacionamentos?.find((item: any) => item === target.extra.id)
    ) {
      setshowModalItemItem(true);
    }
  }, [target, playerInfo]);

  function showRetryButton() {
    // "Tentar novamente" (que chama reset() e apaga o formulário) só para erro
    // transitório/rede (sem código de status de regra de negócio). Rejeições de
    // regra da trigger (limite atingido, auto reconhecimento, lideranca alvo nao
    // gerencial, sem fundos, fase fechada, reconhecimento duplicado, usuário inativo)
    // trazem attributes.status preenchido → não são retentáveis desse jeito.
    // A recusa por moderação também preenche attributes.status, mas É retentável —
    // ela tem seu próprio botão ("Revisar mensagem", ver handleReviewMessage) que
    // preserva o texto em vez de apagá-lo. Robusto: não depende do texto da mensagem.
    return !!submitMessage && !submitStatus;
  }

  function renderFeedbackIcon() {
    if (hasSubmitError) {
      return (
        <span className="rb-recognize__state-icon is-error" aria-hidden="true">
          <TbAlertTriangle size={FEEDBACK_ICON_SIZE} />
        </span>
      );
    }

    if (submitEmAnalise) {
      return (
        <span className="rb-recognize__state-icon is-review" aria-hidden="true">
          <TbClockPause size={FEEDBACK_ICON_SIZE} />
        </span>
      );
    }

    return (
      <span className="rb-recognize__state-icon is-ok" aria-hidden="true">
        {ICONE_POR_NIVEL[nivelByMoeda(coin).id]}
      </span>
    );
  }

  function getFeedbackTitle() {
    /* A recusa por moderação de texto tem título próprio porque é a única
       recusa que a pessoa resolve reescrevendo — sem selos, limite atingido ou
       fase fechada não se resolvem revisando, e mandá-la revisar seria conselho
       inútil. Não confundir com submitEmAnalise, que é o caminho oposto:
       reconhecimento aceito e retido para avaliação humana. */
    if (hasSubmitError) {
      return submitStatus === 'reprovado na moderacao' ? 'Revise seu reconhecimento' : 'Não foi possível enviar';
    }
    return submitEmAnalise ? 'Reconhecimento em análise' : 'Reconhecimento enviado';
  }

  const COIN_ORDER = ['valeu', 'mandou', 'uau'];
  const saldoSelos = gigabytesToSelos(user?.point_categories?.point_behavior || 0);
  const renovaData = currentCycle?.date_finish ? format(new Date(currentCycle.date_finish), 'dd/MM') : '';
  const textLength = messageLength?.textLength || 0;
  const fullLength = messageLength?.fullLength || 0;
  const mensagemValida = textLength >= minTextLength && fullLength <= maxTextLength;
  // Regulamento §2.3/§3.1.4: Liderança Inspiradora só reconhece quem ocupa função gerencial (isLeader do ALVO).
  const alvoGerencial = !!target?.isLeader;
  const dimensoesDisponiveis = DIMENSOES.filter(d => d.id !== 'lideranca' || alvoGerencial);
  const dimensaoSelecionada = dimensaoByBehavior(behavior);

  return (
    <ReactModal
      key={'modal-reconhecer'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Reconhecer"
      portalClassName="modal-reconhecer"
      overlayClassName="rb-recognize-overlay"
      contentElement={() => (
        <>
          {!submitted && (
            <div className="rb-recognize">
              <div className="rb-recognize__header">
                <h2 tabIndex={0}>Reconhecer um colega</h2>
                <button className="rb-recognize__close" aria-label="Fechar" onClick={() => setIsOpen(false)}>
                  ×
                </button>
              </div>

              <div className="rb-recognize__body">
                {!loading && (
                  <>
                    <div className="rb-steps" aria-hidden={true}>
                      {[0, 1, 2, 3].map(i => (
                        <span key={i} className={`rb-steps__dot ${i <= step ? 'is-active' : ''}`}>
                          {i + 1}
                        </span>
                      ))}
                    </div>

                    <p className="rb-recognize__saldo">
                      Você tem{' '}
                      <strong>
                        {saldoSelos} selo{saldoSelos === 1 ? '' : 's'}
                      </strong>{' '}
                      disponíveis neste ciclo{renovaData ? ` (renova em ${renovaData})` : ''}. Máximo de 3 selos por colega/mês.
                    </p>

                    {/* Passo 1 — pessoa */}
                    {step === 0 && (
                      <div className="rb-recognize__step">
                        <label className="rb-recognize__label">Quem você quer reconhecer?</label>
                        {!target ? (
                          <>
                            {searchResults.length === 0 && !searching && (
                              <form className="rb-recognize__searchrow" onSubmit={handleSearch}>
                                <input
                                  type="text"
                                  aria-label="Campo de busca por nome ou matrícula"
                                  placeholder="Buscar por nome, matrícula ou e-mail..."
                                  className="rb-input"
                                  ref={(ref: any) => (searchRef.current = ref)}
                                  onChange={() => handleChange()}
                                />
                                <button type="submit" className="rb-btn-primary" aria-label="Buscar">
                                  <TbSearch size={20} />
                                </button>
                              </form>
                            )}

                            {searching && <p className="rb-recognize__loading">Recuperando informações...</p>}

                            {searchResults.length > 0 && (
                              <div className="rb-recognize__results">
                                {searchResults.map(item => (
                                  <button key={item._id} className="rb-recognize__result" onClick={() => setTarget(item)}>
                                    <div className="rb-recognize__result-avatar">
                                      <UserAvatar data={{ image: item.image, ariaHidden: true, ...item.extra }} responsive={true} />
                                    </div>
                                    <div className="rb-recognize__result-info">
                                      <span className="rb-recognize__result-name">{item.extra?.nome_guerra || item.name}</span>
                                      <span className="rb-recognize__result-meta">
                                        {item.extra?.dependencia} · {item.extra?.funcao}
                                      </span>
                                    </div>
                                  </button>
                                ))}
                              </div>
                            )}

                            {isEmpty && (
                              <p className="rb-recognize__hint">Este e-mail não consta na base de funcionários do Reconheça BRB.</p>
                            )}
                            {!searching && searchResults.length === 0 && searched && !isEmpty && (
                              <p className="rb-recognize__hint">Nenhum colega encontrado. Busque por nome, sobrenome ou e-mail.</p>
                            )}
                          </>
                        ) : (
                          <div className="rb-recognize__selected">
                            <div className="rb-recognize__result-avatar">
                              <UserAvatar data={{ image: target.image, ariaHidden: true, ...target.extra }} responsive={true} />
                            </div>
                            <div className="rb-recognize__result-info">
                              <span className="rb-recognize__result-name">{target.extra?.nome_guerra || target.name}</span>
                              <span className="rb-recognize__result-meta">
                                {target.extra?.dependencia} · {target.extra?.funcao}
                              </span>
                            </div>
                            <button className="rb-recognize__remove" aria-label="Trocar pessoa" onClick={() => reset()}>
                              <RiCloseLine size={20} />
                            </button>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Passo 2 — dimensão */}
                    {step === 1 && (
                      <div className="rb-recognize__step" ref={behaviorRef}>
                        <label className="rb-recognize__label">Dimensão do reconhecimento</label>
                        <div className="rb-recognize__dimlist">
                          {dimensoesDisponiveis.map(dimensao => (
                            <button
                              key={dimensao.id}
                              className={`rb-dimoption ${behavior === dimensao.id ? 'is-selected' : ''}`}
                              style={{ ['--c' as any]: dimensao.color }}
                              onClick={() => setBehavior(dimensao.id)}
                              aria-label={`Selecionar ${dimensao.label}. ${dimensao.descricao}`}
                            >
                              <span className="rb-dimoption__icon" style={{ background: hexToRgba(dimensao.color, 0.12) }}>
                                <DimGlyph id={dimensao.id} color={dimensao.color} size={24} />
                              </span>
                              <span className="rb-dimoption__text">
                                <span className="rb-dimoption__label" style={{ color: dimensao.color }}>
                                  {dimensao.label}
                                </span>
                                <span className="rb-dimoption__desc">{dimensao.descricao}</span>
                              </span>
                            </button>
                          ))}
                        </div>
                        {!alvoGerencial && (
                          <p className="rb-recognize__hint">
                            A dimensão “Liderança Inspiradora” fica disponível apenas para reconhecer colegas em função gerencial.
                          </p>
                        )}
                      </div>
                    )}

                    {/* Passo 3 — nível */}
                    {step === 2 && (
                      <div className="rb-recognize__step" ref={recognitionRef}>
                        {!hasEnoughCoins('uau') && !hasEnoughCoins('mandou') && !hasEnoughCoins('valeu') ? (
                          <div className="rb-recognize__hint">
                            Você não possui saldo de selos para reconhecer. Aguarde até a próxima distribuição.
                          </div>
                        ) : (
                          <>
                            <label className="rb-recognize__label">Nível de reconhecimento</label>
                            <div className="rb-recognize__niveis">
                              {COIN_ORDER.map(coinId => {
                                const nivel = nivelByMoeda(coinId);
                                const enough = hasEnoughCoins(coinId);
                                return (
                                  <button
                                    key={coinId}
                                    disabled={!enough}
                                    className={`rb-nivelopt ${coin === coinId ? 'is-selected' : ''}`}
                                    onClick={() => (enough ? setCoin(coinId) : null)}
                                    aria-label={`Nível ${nivel.tag}, ${nivel.selos} selos. ${GetMoedaDescription(coinId)}`}
                                  >
                                    <span className="rb-nivelopt__tag">{nivel.tag}</span>
                                    <span className="rb-nivelopt__sem">
                                      {enough ? `${nivel.selos} selo${nivel.selos > 1 ? 's' : ''}` : 'Saldo insuficiente'}
                                    </span>
                                    <span className="rb-nivelopt__desc">{nivel.descricao}</span>
                                  </button>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {/* Passo 4 — mensagem + pré-visualização */}
                    {step === 3 && target && behavior && coin && (
                      <div className="rb-recognize__step" ref={feedbackRef}>
                        <label className="rb-recognize__label">Descreva o comportamento observado</label>
                        <textarea
                          className="rb-input rb-recognize__textarea"
                          rows={4}
                          value={message || ''}
                          onChange={e => handleChangeMessage(e.target.value)}
                          placeholder="Seja objetivo: descreva a situação e o comportamento que motivou este reconhecimento."
                        />
                        <div className={`rb-recognize__counter ${fullLength > 0 && textLength < minTextLength ? 'is-error' : ''}`}>
                          {fullLength > 0 && textLength < minTextLength
                            ? `Mínimo de ${minTextLength} caracteres (faltam ${minTextLength - textLength}). `
                            : ''}
                          {fullLength > maxTextLength ? `Limite de ${maxTextLength} caracteres ultrapassado. ` : ''}
                          Evite manifestações genéricas — o regulamento veda elogios sem fundamentação.
                        </div>

                        <div className="rb-recognize__preview">
                          <div className="rb-recognize__preview-title">Pré-visualização</div>
                          <div className="rb-recognize__preview-flow">
                            <span className="rb-recognize__preview-person">
                              <span className="rb-recognize__preview-avatar">
                                <UserAvatar data={{ ...(user || {}), ...(user?.extra || {}), ariaHidden: true }} responsive={true} />
                              </span>
                              <span className="rb-recognize__preview-name">Você</span>
                            </span>
                            <span>enviou</span>
                            <span
                              className="rb-dimchip"
                              style={{
                                color: dimensaoSelecionada.color,
                                boxShadow: `inset 0 0 0 1.5px ${dimensaoSelecionada.color}`,
                              }}
                            >
                              <span className="rb-dimchip__dot" style={{ background: dimensaoSelecionada.color }} />
                              {dimensaoSelecionada.label}
                            </span>
                            <span className="rb-recognize__preview-nivel">{nivelByMoeda(coin).tag}</span>
                            <span>para</span>
                            <span className="rb-recognize__preview-person">
                              <span className="rb-recognize__preview-avatar">
                                <UserAvatar data={{ image: target.image, ariaHidden: true, ...target.extra }} responsive={true} />
                              </span>
                              <span className="rb-recognize__preview-name">
                                {target.extra?.nome_guerra || target.name?.split(' ')[0]}
                              </span>
                            </span>
                          </div>
                          <div
                            className="rb-recognize__preview-message"
                            style={{ ['--acc' as any]: dimensaoSelecionada.color }}
                          >
                            <div className="rb-recognize__preview-label">
                              Sua mensagem para {target.extra?.nome_guerra || target.name?.split(' ')[0]}
                            </div>
                            {!!message ? (
                              <p className="rb-recognize__preview-msg" dangerouslySetInnerHTML={{ __html: convertEmojis(message) }} />
                            ) : (
                              <p className="rb-recognize__preview-msg is-empty">
                                Escreva acima para ver como sua mensagem vai aparecer.
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="rb-recognize__notice">
                          <AiOutlineWarning size={20} />
                          <p>
                            Todos os reconhecimentos ficam visíveis aos outros participantes. Ética e integridade são as bases da
                            confiança.
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Navegação */}
                    <div className="rb-recognize__nav">
                      <button className="rb-btn-ghost" onClick={() => (step === 0 ? setIsOpen(false) : setStep(step - 1))}>
                        {step === 0 ? 'Cancelar' : 'Voltar'}
                      </button>
                      {step < 3 ? (
                        <button
                          className="rb-btn-primary"
                          disabled={(step === 0 && !target) || (step === 1 && !behavior) || (step === 2 && !coin)}
                          onClick={() => setStep(step + 1)}
                        >
                          Continuar
                        </button>
                      ) : (
                        <button className="rb-btn-primary" disabled={!mensagemValida} onClick={() => handleSubmit()}>
                          Enviar reconhecimento
                        </button>
                      )}
                    </div>
                  </>
                )}

                {loading && <div className="rb-recognize__loading" style={{ padding: '30px 0' }}>Enviando reconhecimento...</div>}
              </div>
            </div>
          )}

          {submitted && (
            <div className="rb-recognize" ref={feedbackServer}>
              <div className="rb-recognize__header">
                <h2 tabIndex={0}>{getFeedbackTitle()}</h2>
                <button className="rb-recognize__close" aria-label="Fechar" onClick={() => setIsOpen(false)}>
                  ×
                </button>
              </div>
              <div className="rb-recognize__body">
                {!hasSubmitError ? (
                  <div className="rb-recognize__feedback">
                    {renderFeedbackIcon()}
                    <h1 tabIndex={0}>{submitEmAnalise ? 'Em análise' : nivelByMoeda(coin).celebracao}</h1>
                    <p tabIndex={0}>{submitMessage}</p>
                    <div className="rb-recognize__nav" style={{ justifyContent: 'center' }}>
                      <button className="rb-btn-ghost" onClick={() => reset()}>
                        Reconhecer outro
                      </button>
                      <button className="rb-btn-primary" onClick={() => setIsOpen(false)}>
                        Fechar
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="rb-recognize__feedback">
                    {renderFeedbackIcon()}
                    <p tabIndex={0}>{submitMessage}</p>
                    <div className="rb-recognize__nav" style={{ justifyContent: 'center' }}>
                      {submitStatus === 'reprovado na moderacao' ? (
                        <button className="rb-btn-primary" onClick={() => handleReviewMessage()}>
                          Revisar mensagem
                        </button>
                      ) : (
                        showRetryButton() && (
                          <button className="rb-btn-primary" onClick={() => reset()}>
                            Tentar novamente
                          </button>
                        )
                      )}
                      <button className="rb-btn-ghost" onClick={() => setIsOpen(false)}>
                        Fechar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {showModalItem && (
            <Modal
              onClose={clear => {
                setshowModalItemItem(false);
                if (clear) {
                  setTarget(undefined);
                }
              }}
            />
          )}
        </>
      )}
    />
  );
}
